import {
  ArrowShortDownIcon,
  ArrowShortUpIcon,
  CloseIcon,
  ExclamationMarkIcon,
} from '@fourthwall/icons'
import React, { useState } from 'react'
import { Icon } from '../Icon'
import * as S from './styled'
import type { BannerProps } from './types'

export const Banner = ({
  title,
  subtitle,
  panel,
  appearance = 'info',
  withoutPaddings = false,
  icon = ExclamationMarkIcon,
  size = 'normal',
  justify = 'left',
  children,
  onClose,
}: BannerProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <S.Container
      $appearance={appearance}
      $size={size}
      $withoutPaddings={withoutPaddings}
      role="alert"
      data-testid="Banner"
      $withRightContent={!!onClose}
    >
      <S.Main $justify={justify} $size={size}>
        <S.IconContainer>
          <Icon component={icon} height={size === 'normal' ? 20 : 15} />
        </S.IconContainer>
        <div>
          {title && <S.Title>{title}</S.Title>}
          {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
          {isOpen && panel && <div style={{ marginTop: 8 }}>{panel}</div>}
          {children}
        </div>
      </S.Main>
      {panel && (
        <div>
          <button type="button" onClick={() => setIsOpen((currentIsOpen) => !currentIsOpen)}>
            <Icon component={isOpen ? ArrowShortUpIcon : ArrowShortDownIcon} height={16} />
          </button>
        </div>
      )}
      {onClose && (
        <S.CloseButtonContainer $size={size} onClick={onClose}>
          <Icon component={CloseIcon} height={16} />
        </S.CloseButtonContainer>
      )}
    </S.Container>
  )
}
